<template>
  <div class="el-carousel__container " >
    <img
      :src="images[0].src"
      :alt="images[0].alt"
      draggable="false"
    >
  </div>
</template>

<script>
  export default {
    props: {
      images: {
        type: Array,
        default: () => {
          return []
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.el-carousel__container {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    @media screen and (max-width: 768px) {
      height: 80vw;
      object-fit: cover;
      overflow: hidden;
    }
  }
}
</style>
